module.exports = __webpack_public_path__ + "img/AT0000002617262.b80bb51e.png";